import React, { useState } from 'lib/react';
import {
  EVGrid, EVTypography, EVButton,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import PropTypes from 'prop-types';
import clsx from 'lib/clsx';
import downloadCustomCoverPreviewService from 'services/downloadCustomCoverPreview.service';
import { getPropertyValues } from 'features/orderPreferences/OrderPreferences.utils';
import { LAYOUT_OPTIONS } from 'features/orderPreferences/OrderPreference.constants';
import { EV_IMAGE_FILES_PATH } from 'constants/AppConstants';
import PreviewCoverPageStyles from './PreviewCoverPageStyles';

function PreviewCoverPage(props) {
  const {
    logoFileData, orderPreferences, inputFieldValues,
  } = props;

  const layout = Number(getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsCustomCover')?.value || 1);
  const logoFileId = getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsCoverCompanyLogo')?.value;

  const previewValues = {
    title: getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsCoverTitle').value,
    subTitle: getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsCoverSubTitle').value,
    companyName: getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsCoverCompanyName').value,
    companyStreet: getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsCoverCompanyStreet').value,
    companyCity: getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsCoverCompanyCity').value,
    companyState: getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsCoverCompanyState').value,
    companyZip: getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsCoverCompanyZip').value,
    contactName: getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsCoverContactName').value,
    companyEmail: getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsCoverCompanyEmail').value,
    contactPhone: getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsCoverContactPhone').value,
    companyURL: getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsCoverCompanyURL').value || '',
    customCover: String(layout),
    primaryColor: getPropertyValues(orderPreferences, inputFieldValues, 'reportOptionsCoverPrimaryColor').value,
    companyLogo: String(logoFileId),
  };

  const { t } = useTranslation();
  const [donloadingPreview, setDownloadingPreview] = useState(false);
  const handlePreviewDownload = () => {
    setDownloadingPreview(true);
    downloadCustomCoverPreviewService(previewValues)
      .then(() => setDownloadingPreview(false));
  };

  const {
    title,
    subTitle,
    companyName,
    companyStreet,
    companyCity,
    companyState,
    companyZip,
    contactName,
    contactPhone,
    companyEmail,
    primaryColor,
  } = previewValues;

  const classes = PreviewCoverPageStyles({ primaryColor });

  return (
    <EVGrid className={classes.previewContainer}>
      <EVGrid className={classes.previewSubContainer}>
        <EVTypography className={classes.previewHeadingText}>{t('order_preferences__custom_cover_preview_cover')}</EVTypography>
        <EVGrid className={clsx(classes.previewPaper, `layout${layout}`)}>
          <EVGrid className={clsx(classes.paperTitleBox, `layout${layout}`)}>
            {
              (layout !== LAYOUT_OPTIONS.layout3)
              && (<EVTypography className={clsx(classes.paperHeadingText, `layout${layout}`)}>{title}</EVTypography>)
            }
            {
              (layout !== LAYOUT_OPTIONS.layout2)
             && <EVTypography className={clsx(classes.paperSubHeadingText, `layout${layout}`)}>{subTitle}</EVTypography>
            }
          </EVGrid>
          <EVGrid className={clsx(classes.paperContentBox, `layout${layout}`)}>
            {
            (layout === LAYOUT_OPTIONS.layout3)
            && <EVTypography className={clsx(classes.paperHeadingText, `layout${layout}`)}>{title}</EVTypography>
            }
            <EVGrid className={clsx(classes.paperImage, `layout${layout}`)}>
              <img src={logoFileData} alt="logo" width="100%" />
            </EVGrid>
            {
            (layout === LAYOUT_OPTIONS.layout3 || layout === LAYOUT_OPTIONS.layout2)
            && <EVTypography className={clsx(classes.paperSubHeadingText2, `layout${layout}`)}>{subTitle}</EVTypography>
            }
            <EVGrid className={clsx(classes.paperContentTextBox, `layout${layout}`)}>
              <EVGrid className={clsx(classes.paperAddressTextContainer, `layout${layout}`)}>
                <EVTypography className={clsx(classes.paperAddressText, `layout${layout}`)}>{companyName}</EVTypography>
                <EVTypography className={clsx(classes.paperAddressText, `layout${layout}`)}>{companyStreet}</EVTypography>
                <EVTypography className={clsx(classes.paperAddressText, `layout${layout}`)}>
                  {`${companyCity}, ${companyState}. ${companyZip}`}
                </EVTypography>
              </EVGrid>
              <EVGrid className={classes.paperAddressTextContainer}>
                <EVTypography className={clsx(classes.paperContactText, `layout${layout}`)}>{contactName}</EVTypography>
                <EVTypography className={clsx(classes.paperContactText, `layout${layout}`)}>{contactPhone}</EVTypography>
                <EVTypography className={clsx(classes.paperContactText, `layout${layout}`)}>{companyEmail}</EVTypography>
              </EVGrid>
            </EVGrid>
            <EVGrid className={clsx(classes.paperFooterBox, `layout${layout}`)}>
              <EVTypography className={clsx(classes.paperFooterText, `layout${layout}`)}>
                {t('order_preferences__custom_cover_pdf_footer_text')}
              </EVTypography>
              <img src={`${EV_IMAGE_FILES_PATH}/EagleViewLogoWithText.svg`} alt="EV Logo" className={clsx(classes.logo, `layout${layout}`)} />
            </EVGrid>
          </EVGrid>
        </EVGrid>
      </EVGrid>
      <EVButton
        id="download-preview-btn"
        variant="outlined"
        color="primary"
        className={classes.downloadPrevieweBtn}
        onClick={handlePreviewDownload}
        loading={donloadingPreview}
      >
        {t('order_preferences__custom_cover_download_cover_page')}
      </EVButton>
    </EVGrid>
  );
}

PreviewCoverPage.propTypes = {
  logoFileData: PropTypes.string.isRequired,
  orderPreferences: PropTypes.shape().isRequired,
  inputFieldValues: PropTypes.shape().isRequired,
};
export default PreviewCoverPage;
